export default __webpack_public_path__ + "d77491b3c02853a86009e2acd19540d5.svg";